import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../../configs/AppConfig";
import {AUTH_TIPE} from "../../constants/AuthConstant";

const  tunjanganService = {}

tunjanganService.data = function (token,data='') {
    return fetch({
        url: '/ref/tunjangan/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

tunjanganService.show = function (token,data='') {
    return fetch({
        url: '/ref/tunjangan/show',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

tunjanganService.data_import = function (token,data) {
    return fetch({
        url: '/ref/tunjangan/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

tunjanganService.empty_import = function (token,data) {
    return fetch({
        url: '/ref/tunjangan/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

tunjanganService.save_import = function (token,data) {
    return fetch({
        url: '/ref/tunjangan/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

export default tunjanganService;
